// @flow

import React, { PureComponent } from 'react';
import Button from 'react-aaui/lib/Button';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import { bindActionCreators } from 'redux';
import { claim } from 'modules/result/duck';

import { getPassportLink, hasUsedPortalPath } from 'modules/app/selector';
import { navToPassport } from 'services/navigation/navigation';
import { getEnterprisePersonId, getUserLastName } from 'modules/user/selector';
import { getClaimingState } from 'modules/result/selector';
import Alert from 'react-aaui/lib/alert';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';

import './ClaimTool.scss';

type Props = {
  enterprisePersonId: string,
  passportLink: string,
  userLastName: string,
  lastName: string,
  l10n: L10n,
  resultId: number,
  participantId: number,
  text: string,
  isClaiming: boolean,
  resultHasBeenClaimed: boolean,
  claim: (enterprisePersonId: string, resultId: number, participantId: number) => void,
  isKioskMode: boolean,
  hasPortalPath: boolean
}

class ClaimTool extends PureComponent <Props> {
  handleClaimClick = () => {
    const {
      enterprisePersonId,
      passportLink,
      userLastName,
      lastName,
      l10n: { formatMessage },
      resultId,
      participantId,
    } = this.props;

    if (!enterprisePersonId) {
      navToPassport(passportLink);
    } else if (userLastName && lastName && lastName.toUpperCase() !== userLastName.toUpperCase()) {
      Alert.error({
        message: formatMessage('global.claim.lastName.missMatch'),
        inverse: true,
      });
    } else {
      this.props.claim(enterprisePersonId, resultId, participantId);
    }
  }

  render() {
    const {
      text,
      isClaiming,
      resultHasBeenClaimed,
      hasPortalPath,
      isKioskMode,
    } = this.props;
    const buttonType = 'primary';

    return (
      (!resultHasBeenClaimed && !hasPortalPath && !isKioskMode) ? (
        <div className="claim-tool">
          <Button
            size="sm"
            type={buttonType}
            onClick={() => this.handleClaimClick()}
            disabled={isClaiming}
            loading={isClaiming}>
            {text}
          </Button>
        </div>
      ) : (
        <div className="claim-tool-place-holder" />
      )
    );
  }
}

const mapState = (state: Map<*, *>, { resultId }: any) => ({
  resultId,
  enterprisePersonId: getEnterprisePersonId(state),
  userLastName: getUserLastName(state),
  passportLink: getPassportLink(state),
  isClaiming: getClaimingState(state, resultId),
  hasPortalPath: hasUsedPortalPath(state),
});

const mapDispatch = dispatch => bindActionCreators({ claim }, dispatch);

export default injectL10n()(connect(mapState, mapDispatch)(ClaimTool));
